import store from "../store";
import messages from "@/languages/index"
let language = store.state.language || "pt"

const storeFavorite = (id_sport, id_category, id_tournament) => {

  // recuperando o nome do esporte
  var {
    name_sport
  } = store.state.sports.find(
    (item) => item.id_sport == id_sport
  );

  // Removendo Favorito
  var favoriteIndex;
  let tournament = store.state.favoriteTournaments.find((favorite, index) => {
    if (id_tournament == favorite.id_tournament) {
      favoriteIndex = index;
      return favorite;
    }
  });

  if (tournament) {
    store.commit("removeFavoriteTournaments", favoriteIndex);
    return;
  }

  // Limite Máximo
  if (store.state.favoriteTournaments.length >= 20) {
    const msg = `${messages[language].msgFavoritesLimit} (20)`;
    const color = "warning";
    store.commit("setNotification", {
      msg,
      color
    });
    return;
  }

  // Inserindo Favorito
  store.commit("setFavoriteTournaments", {
    id_sport: id_sport,
    id_category: id_category,
    id_tournament: id_tournament,
    name_sport: name_sport,
  });

}

export default storeFavorite;